<template>
  <div class="test-result">
    <header class="test-result-header">
      <h3 class="header__title">Результаты тестирования:</h3>
    </header>
    <div class="test-result-body">
      <ul class="test-result-body-list">
        <li
          v-for="(result, index) in results"
          :key="index"
          class="test-result-body-list__item"
        >
          <span class="test-result-body-list__item-name">{{ result.category_name }}</span>
          <div class="test-result-body-list__item_right">
            <div class="test-result-body-list__item_right-progress">
              <app-progress-bar
                :percent="result.percent"
                :width="200"
              />
            </div>
            <span class="test-result-body-list__item_right-percent">{{ result.percent }} %</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import AppProgressBar from '../Base/AppProgressBar';

export default {
  name: 'TestResult',
  components: {
    AppProgressBar,
  },
  props: {
    results: {
      type: Array,
      default() {
        return '';
      },
    },
  },
};
</script>

<style lang="scss" scoped>
  .test-result {
    background: #FFFFFF;
    border: 1px solid #DBDBDB;
    box-sizing: border-box;
    box-shadow: 0 4px 14px rgba(70, 97, 138, 0.2);
    border-radius: 8px;
    padding: 24px;
    width: 872px;

    &-header {
      &__title {
        margin: 0;
        padding: 0;
        font-size: 23px;
      }
    }

    &-body {
      border-top: 1px solid #DBDBDB;
      margin-top: 24px;
      &-list {
        list-style-type: none;
        padding: 0;
        &__item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 30px 0;
          font-size: 17px;
          &-name {
            width: 65%;
          }
          &_right {
            align-items: center;
            display: flex;
            flex-direction: row;
            width: 35%;
            &-progress {
              width: 75%;
            }
            &-percent {
              text-align: center;
              width: 25%;
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 576px) {
    .test-result {
      width: 288px;
      &-body {
        &-list {
          &__item {
            flex-direction: column;
            border-bottom: 1px solid #DBDBDB;
            &-name {
              width: 100%;
            }
            &_right {
              padding: 15px 0 25px 0;
              width: 100%;
            }
          }
        }
      }
    }
  }
</style>
